import { render, staticRenderFns } from "./SpComponent.vue?vue&type=template&id=98987388&scoped=true&"
import script from "./SpComponent.vue?vue&type=script&lang=js&"
export * from "./SpComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpComponent.vue?vue&type=style&index=0&id=98987388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98987388",
  null
  
)

export default component.exports